import { Card, Col, Row } from 'react-bootstrap';
import CircularPieCharts from './CircularPieCharts';
import Flex from '@/components/common/Flex';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const SpeedOverviewSkeleton = () => {
  return (
    <>
      <Card className="my-3">
        <Card.Body>
          <Flex className="align-items-center flex-column flex-lg-row justify-content-center gap-3">
            <Row className="justify-content-center align-items-center g-4">
              {Array.from({ length: 5 }).map((_, index) => (
                <Col key={index} xs="auto">
                  <div className="d-flex flex-column gap-1 align-items-center">
                    <CircularPieCharts
                      data={{
                        score: 0,
                        id: 'loading',
                        name: 'loading...'
                      }}
                    />
                    <div className="fw-boldtext-center fs-0">
                      <TextLoading width={80} height={16} isWidthPx />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <TextLoading width={211} isWidthPx height={169} />
          </Flex>
        </Card.Body>
      </Card>
    </>
  );
};

export default SpeedOverviewSkeleton;
